import React from 'react';
import PropTypes from 'prop-types';
import V3OfferLineupList from './V3OfferLineupList';
import V3OfferPoolToggle from './V3OfferPoolToggle';
import '../styles/lineup.css';

function formatCurrency(amount) {
  const total = Number(amount) || 0;
  return `$${total.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}

function totalGuarantees(lineup) {
  return lineup.reduce((sum, o) => sum + (Number(o.dollar_amount) || 0), 0);
}

const V3OfferLineupRail = ({
  lineup,
  activeOfferId,
  onSelectOffer,
  onAddArtist,
  onReorder,
  team,
  offer,
  poolActive,
  poolMembers,
}) => {
  // O-2783: in Pool mode each member's individual guarantee is 0 (the deal lives
  // on the pool), so the cards/footer show the member's computed pool take
  // instead. poolMembers come from FinancialSummaryMath keyed by performerId,
  // which matches the lineup row's performer_id (see buildPoolEngineInput).
  // `poolActive` MUST be the authoritative pool-mode flag (isPoolPreviewActive)
  // — NOT inferred from poolMembers.length, which is non-empty even in
  // Independent mode (the engine's single-artist branch returns a 1-element
  // array keyed by performerId:null).
  const takeByPerformerId = new Map((poolMembers || []).map((m) => [m.performerId, m.take]));
  const poolTotal = (poolMembers || []).reduce((sum, m) => sum + (Number(m.take) || 0), 0);

  return (
    <aside className="lineup-rail">
      <header className="lineup-rail__header">
        <span className="lineup-rail__title">LINEUP</span>
      </header>

      {/* O-2783: Independent | Pool mode toggle. Self-gates on the package
        * entitlement, so it renders nothing when the feature is off. */}
      <V3OfferPoolToggle team={team} offer={offer} />

      <V3OfferLineupList
        lineup={lineup}
        activeOfferId={activeOfferId}
        onSelectOffer={onSelectOffer}
        onAddArtist={onAddArtist}
        onReorder={onReorder}
        poolActive={poolActive}
        takeByPerformerId={takeByPerformerId}
      />

      <footer className="lineup-rail__footer">
        <div className="lineup-rail__totals">
          <span>{poolActive ? 'Pool total' : 'Total guarantees'}</span>
          <span>{formatCurrency(poolActive ? poolTotal : totalGuarantees(lineup))}</span>
        </div>
      </footer>
    </aside>
  );
};

V3OfferLineupRail.propTypes = {
  lineup: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeOfferId: PropTypes.number,
  onSelectOffer: PropTypes.func.isRequired,
  onAddArtist: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  team: PropTypes.object,
  offer: PropTypes.object,
  poolActive: PropTypes.bool,
  poolMembers: PropTypes.arrayOf(PropTypes.object),
};

V3OfferLineupRail.defaultProps = {
  activeOfferId: null,
  team: null,
  offer: null,
  poolActive: false,
  poolMembers: [],
};

export default V3OfferLineupRail;
